import axios from "axios";
import { createContext, useContext, useState } from "react";
import { findapiserverurl } from "./api.service";

/* -------------------------------------------------------------------------------- *\
|                               LoginType
\* -------------------------------------------------------------------------------- */
export type LoginType =
{
	username: string;
	password: string;
}
/* -------------------------------------------------------------------------------- *\
|                               ProviderProps
\* -------------------------------------------------------------------------------- */
interface ProviderProps
{
	user: string | null,
	token: string,
	login(data: LoginType): Promise<any>,
	logout(): void,
}

/* -------------------------------------------------------------------------------- *\
|                               AuthContext
\* -------------------------------------------------------------------------------- */
const AuthContext = createContext<ProviderProps>({
	user: null,
	token: '',
	login: async (data: LoginType)  => { Promise.resolve() },
	logout: () => { }
})

/* -------------------------------------------------------------------------------- *\
|                               AuthProvider
\* -------------------------------------------------------------------------------- */
export const AuthProvider = ({ children }: { children: React.ReactNode }) =>
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null
	const [user, setUser] = useState<string | null>(storedInfo?.username)
	const [token, setToken] = useState(storedInfo?.accessToken || '')

	const login = async (data: LoginType) =>
	{
		const response = await axios.post(findapiserverurl() + "/api/signin", data);
		setUser(data.username);
		setToken(response.data.accessToken);
		localStorage.setItem('user', JSON.stringify(response.data));
		return response.data;
	}

	const logout = () =>
	{
		setUser(null)
		setToken('')
		localStorage.removeItem('user')
	}

	return (
		<AuthContext.Provider value= {{ user: user, token: token, login: login, logout: logout }}>
			{ children }
		</AuthContext.Provider>
  	);
}
/* -------------------------------------------------------------------------------- *\
|                               useAuthContext
\* -------------------------------------------------------------------------------- */
export const useAuthContext = () =>
{
    return useContext(AuthContext)
}